import { cn } from '../../../lib/utils';
import {
    ADMIN_BADGE_SOLID_GREEN_CLASS,
    ADMIN_BADGE_SOLID_RED_CLASS,
} from './adminSolidStatusBadge';

export function AdminActiveStatusBadge({
    isActive,
    className,
}: {
    isActive: boolean;
    className?: string;
}) {
    return (
        <span
            className={cn(
                'inline-flex max-w-max items-center rounded-full px-2 py-0.5 text-xs font-semibold',
                isActive ? ADMIN_BADGE_SOLID_GREEN_CLASS : ADMIN_BADGE_SOLID_RED_CLASS,
                className,
            )}
        >
            {isActive ? 'Active' : 'Inactive'}
        </span>
    );
}
